/**
 * Data layer for `on-the-go-campaign-monitoring-in-mobile-app`. Thin typed fetch wrappers over /api/v1/on-the-go-campaign-monitoring-in-mobile-app.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface OnTheGoCampaignMonitoringInMobileAppRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListOnTheGoCampaignMonitoringInMobileAppResponse {
	count: number;
	items: OnTheGoCampaignMonitoringInMobileAppRow[];
}

export interface CreateOnTheGoCampaignMonitoringInMobileAppBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/on-the-go-campaign-monitoring-in-mobile-app";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListOnTheGoCampaignMonitoringInMobileAppResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListOnTheGoCampaignMonitoringInMobileAppResponse>(res);
}

export async function create(body: CreateOnTheGoCampaignMonitoringInMobileAppBody): Promise<OnTheGoCampaignMonitoringInMobileAppRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<OnTheGoCampaignMonitoringInMobileAppRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const onTheGoCampaignMonitoringInMobileAppQueryKeys = {
	all: ["on-the-go-campaign-monitoring-in-mobile-app"] as const,
	list: () => [...onTheGoCampaignMonitoringInMobileAppQueryKeys.all] as const,
	detail: (id: string) => [...onTheGoCampaignMonitoringInMobileAppQueryKeys.all, id] as const,
};
